import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import "./AnimatedChart.css";

function AnimatedChart() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    // Create gradient fills
    const gradientRed = ctx.createLinearGradient(0, 0, 0, 400);
    gradientRed.addColorStop(0, "rgba(227, 30, 36, 0.6)");
    gradientRed.addColorStop(1, "rgba(227, 30, 36, 0.05)");

    const gradientGrey = ctx.createLinearGradient(0, 0, 0, 400);
    gradientGrey.addColorStop(0, "rgba(74, 74, 74, 0.6)");
    gradientGrey.addColorStop(1, "rgba(74, 74, 74, 0.05)");

    const gradientBlack = ctx.createLinearGradient(0, 0, 0, 400);
    gradientBlack.addColorStop(0, "rgba(26, 26, 26, 0.6)");
    gradientBlack.addColorStop(1, "rgba(26, 26, 26, 0.05)");

    // Destroy existing chart if it exists
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    chartInstance.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: ["2020", "2021", "2022", "2023", "2024", "2025"],
        datasets: [
          {
            label: "AI Implementation",
            data: [20, 35, 55, 70, 85, 95],
            borderColor: "#E31E24",
            backgroundColor: gradientRed,
            borderWidth: 3,
            tension: 0.4,
            fill: true,
            pointRadius: 6,
            pointHoverRadius: 8,
            pointBackgroundColor: "#E31E24",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#E31E24",
            pointHoverBorderWidth: 3,
          },
          {
            label: "Cloud Adoption",
            data: [30, 45, 60, 75, 88, 92],
            borderColor: "#4A4A4A",
            backgroundColor: gradientGrey,
            borderWidth: 3,
            tension: 0.4,
            fill: true,
            pointRadius: 6,
            pointHoverRadius: 8,
            pointBackgroundColor: "#4A4A4A",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#4A4A4A",
            pointHoverBorderWidth: 3,
          },
          {
            label: "Business Growth",
            data: [25, 40, 65, 80, 90, 98],
            borderColor: "#1A1A1A",
            backgroundColor: gradientBlack,
            borderWidth: 3,
            tension: 0.4,
            fill: true,
            pointRadius: 6,
            pointHoverRadius: 8,
            pointBackgroundColor: "#1A1A1A",
            pointBorderColor: "#fff",
            pointBorderWidth: 2,
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#1A1A1A",
            pointHoverBorderWidth: 3,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: false,
        },
        plugins: {
          title: {
            display: true,
            text: "Technology Adoption & Business Growth Trends",
            font: {
              size: 20,
              weight: "bold",
              family: "Inter",
            },
            color: "#1A1A1A",
            padding: {
              top: 10,
              bottom: 30,
            },
          },
          legend: {
            display: true,
            position: "bottom",
            labels: {
              padding: 20,
              font: {
                size: 14,
                family: "Inter",
              },
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            backgroundColor: "rgba(0, 0, 0, 0.9)",
            padding: 16,
            cornerRadius: 12,
            titleFont: {
              size: 16,
              weight: "bold",
            },
            bodyFont: {
              size: 14,
            },
            displayColors: true,
            callbacks: {
              label: function (context) {
                return context.dataset.label + ": " + context.parsed.y + "%";
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                size: 14,
                weight: "500",
              },
              color: "#4A4A4A",
            },
          },
          y: {
            beginAtZero: true,
            max: 100,
            ticks: {
              callback: function (value) {
                return value + "%";
              },
              font: {
                size: 14,
                weight: "500",
              },
              color: "#4A4A4A",
              stepSize: 20,
            },
            grid: {
              color: "rgba(0, 0, 0, 0.06)",
              lineWidth: 1,
            },
          },
        },
        animation: {
          duration: 2500,
          easing: "easeInOutQuart",
          delay: (context) => {
            return context.dataIndex * 100 + context.datasetIndex * 200;
          },
        },
        onHover: (event, activeElements) => {
          ctx.canvas.style.cursor =
            activeElements.length > 0 ? "pointer" : "default";
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, []);

  return (
    <div className="animated-chart">
      <canvas ref={chartRef}></canvas>
    </div>
  );
}

export default AnimatedChart;
